export const COMPENSATION_STATUS_COMPENSATED = 'Compensated';
export const COMPENSATION_STATUS_FAILED = 'Failed';
export const COMPENSATION_STATUS_NOT_ENTITLED = 'Not Entitled';

export const COMPENSATION_TICKET_METHOD_PRR_FORM_CARD = 'PRR Form - Card';
